import React, {useState,useEffect} from "react"
import MainContainer from "../../common/CWrapper"
import CarLoanIndex from "./CarLoanIndex"
import EmpInformation from "./EmpImformation"
import BasicDetails from "./BaiscDetails"
import CustInformation from "./CustomerInformation"
import StatusBlock from "./Status"
import TrackStatus from "./TrackStatusIndex"
import TrackStatusApplications from "./TrackStatusApplications"

export default function Profile (props){
    const [activeScreen, setActiveScreen] = useState("CarLoanIndex");
    const [applicationIds, setApplicationIds] = useState([]);
    const [applicationId, setApplicationId] = useState("");
    const [basicData,setBasicData] = useState({})
    const [otpData,setOtpData] = useState({requestId : ""})
    const [statusData,setStatusData] = useState({})
    const [fromScreen,setFromScreen] = useState("")



    function renderSwitch() {
        switch(activeScreen) {
            case 'CarLoanIndex':
                return <CarLoanIndex  setActiveScreen = {setActiveScreen} />;
            case "BasicDetails":
                return <BasicDetails setActiveScreen = {setActiveScreen} setBasicData = {setBasicData} setOtpData = {setOtpData}/>
            case "CustInformation":
                return <CustInformation setActiveScreen = {setActiveScreen} fromScreen={setFromScreen} setStatusData = {setStatusData} basicData = {basicData} navigation = {props.navigation} otpData = {otpData}/>
            case "EmpInformation":
                return <EmpInformation setActiveScreen = {setActiveScreen} statusData = {statusData}/>
            case "StatusBlock":
                return <StatusBlock setActiveScreen = {setActiveScreen} applicationId={applicationId} fromScreen={fromScreen} statusData = {statusData}/>
            case "TrackStatus" : 
                return <TrackStatus setActiveScreen = {setActiveScreen} setStatusData = {setStatusData} setApplicationIds={setApplicationIds} setFromScreen={setFromScreen} />
            case "TrackStatusApplications" : 
                return <TrackStatusApplications setActiveScreen = {setActiveScreen} setStatusData = {setStatusData} applicationIds={applicationIds} />
            default:
                return <StatusBlock />;
        }
      }

   
    return (
        <>
         
               
            
        <MainContainer isCustInfo={activeScreen == 'CustInformation'}>
                {renderSwitch()}
        </MainContainer>
        </>
       
            
    )
}





